"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var material_1 = require("@angular/material");
var expense_service_1 = require("./expense.service");
var organization_service_1 = require("../organizations/organization.service");
var api_service_1 = require("../shared/api.service");
var index_1 = require("../shared/dialogs/index");
var EditExpenseComponent = /** @class */ (function () {
    function EditExpenseComponent(route, router, expenseService, organizationService, dialog) {
        this.route = route;
        this.router = router;
        this.expenseService = expenseService;
        this.organizationService = organizationService;
        this.dialog = dialog;
        this.loading = true;
        this.editing = false;
        this.errors = [];
    }
    EditExpenseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loading = true;
        this.route.params
            .subscribe(function (params) { return _this.getExpense(params['id']); });
    };
    EditExpenseComponent.prototype.getExpense = function (id) {
        var _this = this;
        if (id) {
            this.expenseService.getExpense(id).subscribe(function (res) {
                _this.expense = res;
                var _createdAt = _this.expense.createdAt && new Date(_this.expense.createdAt);
                if (_createdAt) {
                    _this.createdAt = _createdAt;
                }
                _this.loading = false;
            }, function (err) {
                _this.errors = api_service_1.parseErrors(err);
            });
        }
    };
    EditExpenseComponent.prototype.updateExpense = function (update) {
        if (update === void 0) { update = false; }
        if (update) {
            this.getExpense(this.expense.id);
        }
    };
    EditExpenseComponent.prototype.fileChange = function (e) {
        var _this = this;
        console.log('photo event triggered');
        console.log(e);
        var file = e.target.files[0];
        var reader = new FileReader();
        reader.onload = function (_e) {
            _this.expense.ownerOrganization.image = _e.target['result'];
        };
        reader.readAsDataURL(file);
        this.organizationService.saveOnlyImage(this.expense.ownerOrganization.id, file).subscribe(function (organization) {
            _this.save();
        }, function (err) {
            _this.errors = api_service_1.parseErrors(err);
            _this.loading = false;
        });
    };
    EditExpenseComponent.prototype.save = function () {
        var _this = this;
        this.loading = true;
        this.expenseService.save(this.expense).subscribe(function () {
            _this.loading = false;
        }, function (err) {
            _this.errors = api_service_1.parseErrors(err);
            _this.loading = false;
        });
    };
    EditExpenseComponent.prototype.submit = function () {
        var _this = this;
        this.loading = true;
        this.confirmDialog = this.dialog.open(index_1.RuckitConfirmDialogComponent, {
            width: '430px',
            height: '250px'
        });
        this.confirmDialog.componentInstance.attributes = {
            title: 'Send Expense?',
            body: 'Are you sure you want to send this expense? You will no longer be able to edit the expense once it has been sent.',
            close: 'Cancel',
            accept: 'Send'
        };
        this.confirmDialog.afterClosed().subscribe(function (dialogResult) {
            if (dialogResult) {
                _this.loading = true;
                _this.expenseService.save(_this.expense).subscribe(function () {
                    _this.expenseService.send(_this.expense).subscribe(function () {
                        _this.loading = false;
                        _this.router.navigate(['/expenses/filter/paid']);
                    }, function (err) {
                        _this.errors = api_service_1.parseErrors(err);
                        _this.loading = false;
                    });
                }, function (err) {
                    _this.errors = api_service_1.parseErrors(err);
                    _this.loading = false;
                });
            }
            else {
                _this.loading = false;
            }
            _this.confirmDialog = null;
        });
    };
    EditExpenseComponent.prototype.onDateChanged = function (values) {
        if (values && values.length) {
            this.createdAt = values[0];
            this.expense.createdAt = values[0];
        }
    };
    EditExpenseComponent.prototype.changeSearch = function (term) {
        this.search = term || '';
    };
    return EditExpenseComponent;
}());
exports.EditExpenseComponent = EditExpenseComponent;
